import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";

class DemandeAchatService {
  createDemandeAchat(data) {
    return api.post(UtilsUrl.demandeAchatURL() + "/create", data);
  }

  getAllDemandes(idUser, isDeleted) {
    return api.get(UtilsUrl.demandeAchatURL() + "/getAll/" + idUser + "/" + isDeleted);
  }

  getDemandesByStatut(idUser, statut) {
    return api.get(UtilsUrl.demandeAchatURL() + "/getByStatut/" + idUser + "/" + statut);
  }

  getDemandesByFilters(idUser, dateDebut, dateFin, statut) {
    return api.get(
      UtilsUrl.demandeAchatURL() +
        "/getByFilters/" + idUser + "/" + dateDebut + "/" + dateFin + "/" + statut
    );
  }

  getDemandeById(id) {
    return api.get(UtilsUrl.demandeAchatURL() + "/getById/" + id);
  }

  updateStatut(id, statut) {
    return api.put(UtilsUrl.demandeAchatURL() + "/updateStatut/" + id + "/" + statut);
  }

  addReferencesDevis(id, references) {
    return api.put(UtilsUrl.demandeAchatURL() + "/addReferencesDevis/" + id, references);
  }

  accepterDevis(id, devisAccepte, bonCommandeAchat) {
    return api.put(UtilsUrl.demandeAchatURL() + "/accepterDevis/" + id, {
      devisAccepte,
      bonCommandeAchat,
    });
  }

  deleteDemande(id) {
    return api.delete(UtilsUrl.demandeAchatURL() + "/delete/" + id);
  }
}

export default new DemandeAchatService();
